import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts a string to Title Case (first letter of each word capitalized).
 * Handles edge cases like all-lowercase, ALL-CAPS, and mixed input.
 * Preserves common acronyms/abbreviations (LLC, HVAC, AC, etc.).
 */
export function toTitleCase(str: string | null | undefined): string {
  if (!str) return str as string;
  
  const acronyms = new Set([
    'LLC', 'INC', 'CO', 'HVAC', 'AC', 'USA', 'US', 'IT', 'AI', 'SEO',
    'DBA', 'LP', 'LLP', 'PC', 'PA', 'MD', 'DDS', 'DMD', 'PHD', 'II', 'III', 'IV',
  ]);

  return str
    .split(/\s+/)
    .map((word) => {
      const upper = word.toUpperCase();
      if (acronyms.has(upper)) return upper;
      if (word.length === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}
